const stateObj = {
  showPtc: null,
  showSpf: null,
  showFai: null,
  showContactInfoModal: null,
  showEmploymentInfoModal: null,
  showInvestmentProfileModal: null,
  showPersonalInfoModal: null,
  setAcknowledge: null,
  showRiskChanged: null,
  riskChangedAction: null,
  unsavedRiskScore: null,
  showGoalAllocation: null,
  showChangeInvestmentModelModal: null,
};

const getters = {};

const actions = {
  setShowPtc({commit}, payload) {
    commit('SET_SHOW_PTC', payload);
  },
  setShowSpf({commit}, payload) {
    commit('SET_SHOW_SPF', payload);
  },
  setShowFai({commit}, payload) {
    commit('SET_SHOW_FAI', payload);
  },
  setShowContactModal({commit}, payload) {
    commit('SET_SHOW_CONTACT_INFO_MODAL', payload);
  },
  setShowEmploymentInfoModal({commit}, payload) {
    commit('SET_SHOW_EMPLOYMENT_INFO_MODAL', payload);
  },
  setShowInvestmentProfileModal({commit}, payload) {
    commit('SET_SHOW_INVESTMENT_PROFILE_MODAL', payload);
  },
  setShowPersonalInfoModal({commit}, payload) {
    commit('SET_SHOW_PERSONAL_INFO_MODAL', payload);
  },
  setAcknowledge({commit}, payload) {
    commit('SET_ACKNOWLEDGE', payload);
  },
  setRiskChanged({commit}, payload) {
    commit('SET_RISK_CHANGED', payload);
  },
  setShowGoalAllocation({commit}, payload) {
    commit('SET_SHOW_GOAL_ALLOCATION', payload);
  },
  setChangeInvestmentModelModal({commit}, payload) {
    commit('SET_CHANGE_INVESTMENT_MODEL_MODAL', payload);
  },
  resetAllModal({commit}) {
    commit('RESET_ALL');
  },
};

const mutations = {
  SET_SHOW_PTC(state, payload) {
    state.showPtc = payload;
  },
  SET_SHOW_SPF(state, payload) {
    state.showSpf = payload;
  },
  SET_SHOW_FAI(state, payload) {
    state.showFai = payload;
  },
  SET_SHOW_CONTACT_INFO_MODAL(state, payload) {
    state.showContactInfoModal = payload;
  },
  SET_SHOW_EMPLOYMENT_INFO_MODAL(state, payload) {
    state.showEmploymentInfoModal = payload;
  },
  SET_SHOW_INVESTMENT_PROFILE_MODAL(state, payload) {
    state.showInvestmentProfileModal = payload;
  },
  SET_SHOW_PERSONAL_INFO_MODAL(state, payload) {
    state.showPersonalInfoModal = payload;
  },
  SET_ACKNOWLEDGE(state, payload) {
    state.setAcknowledge = payload;
  },
  SET_RISK_CHANGED(state, payload) {
    state.showRiskChanged = payload.visible;
    state.riskChangedAction = payload.action;
    state.unsavedRiskScore = payload.riskScore;
  },
  SET_SHOW_GOAL_ALLOCATION(state, payload) {
    state.showGoalAllocation = payload;
  },
  SET_CHANGE_INVESTMENT_MODEL_MODAL(state, payload) {
    state.showChangeInvestmentModelModal = payload;
  },
  RESET_ALL(state) {
    Object.assign(state, {...stateObj});
  },
};

export default {
  namespaced: true,
  state: {...stateObj},
  getters,
  actions,
  mutations,
};
